import AsyncImage from './AsyncImage';

export default AsyncImage;
